export const GIFT_CARD_HREF = '/giftcard';

// Hero facts of the gift landing pages (HeroFacts in components/landing/hero.js).
export const GIFT_FACTS = [
  { icon: 'penLine', desktop: 'Add a printed gift note', phone: 'Gift note' },
  { icon: 'flag', desktop: 'Printed in the USA' },
  { icon: 'leaf', desktop: 'FSC-certified paper', phone: 'FSC paper' },
];
